import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { caseCollaboratorsQueryOptions, useCaseCollaboratorCanPostMutation } from "@/features/case-record/api/queries/case-collaborator-query";
import { IconLock, IconLockOpen2 } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import clsx from "clsx";
import { useForm } from "react-hook-form";

export default function CaseEvaluationActivitySettingsModal({ caseId }: { caseId: string }) {
	const modal = useModal();
	const query = useQuery(
		caseCollaboratorsQueryOptions({
			case_record_id: caseId,
			status: "",
		}),
	);
	const collaborators = query.data?.data;

	const caseCollaboratorCanPost = useCaseCollaboratorCanPostMutation();

	const form = useForm({
		defaultValues: {},
	});

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<table className="text-sm">
						<thead>
							<tr className="border-b-2 border-border/50">
								<th className="w-[220px] text-left text-foreground-dark p-3">Name</th>
								<th className=" text-left text-foreground-dark p-3">Role</th>
								<th className=" text-left text-foreground-dark p-3">Lock Activity</th>
								<th className=" text-right text-foreground-dark p-3" />
							</tr>
						</thead>
						<tbody>
							{collaborators?.map((collaborator, index) => (
								<tr key={index} className="border-b border-border/50 last:border-b-0">
									<td className="px-3 py-2">{collaborator.user?.full_name}</td>
									<td className="px-3 py-2">{collaborator.role}</td>
									<td className="px-3 py-2">{collaborator.can_add_activity ? "Unlocked" : "Locked"}</td>
									<td className="px-3 py-2 text-right">
										<button
											className={clsx(
												"inline-flex justify-center items-center h-[28px] w-[100px] rounded-md px-3 gap-1 ",
												collaborator.can_add_activity
													? "bg-danger-600/10 hover:bg-danger-600/20 text-danger-600"
													: "bg-green-600/10 hover:bg-green-600/20 text-green-600",
											)}
											onClick={() => {
												modal.openModal({
													title: `${collaborator.can_add_activity ? "Lock" : "Unlock"} "Add Activity"`,
													description: `You are ${collaborator.can_add_activity ? "locking" : "unlocking"} this user to add activity. Please confirm`,
													type: "confirm",
													variant: "green",
													onConfirm: async () => {
														await caseCollaboratorCanPost.mutateAsync({
															id: collaborator.id,
															can_add_activity: !collaborator.can_add_activity,
														});
													},
												});
											}}
											type="button"
										>
											{collaborator.can_add_activity ? (
												<>
													<IconLock size={14} stroke={2} />
													<span className="font-semibold">Lock</span>
												</>
											) : (
												<>
													<IconLockOpen2 size={14} stroke={2} />
													<span className="font-semibold">Unlock</span>
												</>
											)}
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</form>
		</Form>
	);
}
